<template>
  <el-dialog :title="$t('message.customColumns')" :visible="visible" width="680px"
    custom-class="payment-column-settings-dialog" :close-on-click-modal="false"
    @update:visible="$emit('update:visible', $event)">
    <el-checkbox-group v-model="selectedColumns" class="column-settings-list">
      <el-checkbox v-for="item in columns" :key="item.key" :label="item.key">
        {{ $t(item.labelKey) }}{{ item.suffix || '' }}
      </el-checkbox>
    </el-checkbox-group>
    <span slot="footer" class="dialog-footer">
      <el-button @click="selectAll">{{ $t('message.showAllColumns') }}</el-button>
      <el-button @click="close">{{ $t('message.cancel') }}</el-button>
      <el-button type="primary" @click="save">{{ $t('message.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    columns: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedColumns: [],
    }
  },
  watch: {
    visible(value) {
      if (value) {
        const availableKeys = this.columns.map(item => item.key)
        this.selectedColumns = this.value.filter(key => availableKeys.includes(key))
      }
    },
  },
  methods: {
    selectAll() {
      this.selectedColumns = this.columns.map(item => item.key)
    },
    close() {
      this.$emit('update:visible', false)
    },
    save() {
      this.$emit('save', [...this.selectedColumns])
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.column-settings-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px 12px;

  /deep/.el-checkbox {
    margin-right: 0;
  }
}

/deep/.payment-column-settings-dialog .el-dialog__body {
  padding-left: 40px;
  padding-right: 40px;
}
</style>
